import {createSlice, createSelector, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk, RootState} from "../../app/store";
import {CelebrationModel} from '../../models/modelsCelebration';
import Config from "../../config";


interface CelebrationsState {
  celebrations: CelebrationModel[];
}

const initialState: CelebrationsState = {
  celebrations: []
};

export const celebrationsSlice = createSlice({
  name: "celebrations",
  initialState,
  reducers: {
    storeCelebrations: (state, action: PayloadAction<CelebrationModel[]>) => {
      //add celebrations to store
      state.celebrations.push(...action.payload);
    },
    consumeCelebration: (state, action: PayloadAction<number>) => {
      //remove celebration from store
      state.celebrations.splice(0, action.payload);
    },
    purgeStore: (state) => {
      state.celebrations = [];
    },
  },
});

export const { storeCelebrations, consumeCelebration, purgeStore } = celebrationsSlice.actions;


export const selectCelebration = (state: RootState) => {
  return state.celebrationsStore.celebrations[0];
}

export default celebrationsSlice.reducer;
